import CardsSection from "./components/cards";
import HeaderSection from "./components/header/inde";
import TableSection from "./components/table";
import { UserManagementWrapper } from "./styles";
import UserRounded from "@assets/svg/UserRounded.svg?react";
import UserCheckRounded from "@assets/svg/UserCheckRounded.svg?react";
import CarbonClean from "@assets/svg/CarbonClean.svg?react";
import { useGetAllOwnerUsers } from "@services";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingWrapper } from "@components";
import { ReservationFiltersState } from "../ReservationManagement/ReservationFilters";

export default function UserManagement() {
  /* ------------------------------- Local State ------------------------------ */
  const [activePage, setActivePage] = useState(1);
  const [perPage, onPerPageChange] = useState("20");
  const [filters, setFilters] = useState<ReservationFiltersState>({
    dateRange: null,
    selectedChannels: [],
    selectedNames: [],
    priceRange: [0, 1000],
    enum: [],
  });
  
  // Add name search term state
  const [nameSearchTerm, setNameSearchTerm] = useState("");
  
  const { t } = useTranslation();

  const handleFiltersChange = (newFilters: ReservationFiltersState) => {
    // Convert translated enum values back to English keys for backend
    const enumMapping = {
      [t("UserManagement.team_member")]: "TeamMember",
      [t("UserManagement.service_providers")]: "ServiceProvider"
    };
    
    const convertedFilters = {
      ...newFilters,
      enum: newFilters.enum.map(displayValue => 
        enumMapping[displayValue] || displayValue
      )
    };
    
    setFilters(convertedFilters);
    // Reset to first page when filters change
    setActivePage(1);
  };

  const handleClearFilters = () => {
    setFilters({
      dateRange: null,
      selectedChannels: [],
      selectedNames: [],
      priceRange: [0, 1000],
      enum: [],
    });
    setNameSearchTerm(""); // Clear name search term to empty string
    setActivePage(1);
  };

  // Handle name search term change
  const handleNameSearchChange = (searchTerm: string) => {
    setNameSearchTerm(searchTerm);
    // Reset to first page when search term changes
    setActivePage(1);
  };

  /* ---------------------------------- API'S --------------------------------- */
  const { data, isLoading } = useGetAllOwnerUsers({
    pageNumber: activePage,
    pageSize: perPage,
    name: nameSearchTerm || filters.selectedNames[0], // Use search term first, then selected names
    userTypes: filters.enum
  });

  const dataList = [
    {
      label: t("UserManagement.total_users"),
      value: data?.result.usersCount ?? 0,
      icon: <UserRounded />,
    },
    {
      label: t("UserManagement.active_users"),
      value: data?.result.activeUsersCount ?? 0,
      icon: <UserCheckRounded />,
    },
    {
      label: t("UserManagement.service_providers"),
      value: data?.result.serviceProvidersCount ?? 0,
      icon: <CarbonClean />,
    },
  ];
  return (
    <UserManagementWrapper>
        <HeaderSection />
        <div className="containerCardsSection">
          {dataList.map((item, index) => {
            return <CardsSection dataList={item} key={index} />;
          })}
        </div>
        <TableSection 
          totalRecords={data?.result.pagination.totalRecords ?? 0}
          totalPages={data?.result.pagination.totalPages ?? 0}
          activePage={activePage}
          perPage={perPage}
          setActivePage={setActivePage}
          onPerPageChange={onPerPageChange}
          dataList={data}
          filters={filters}
          onFiltersChange={handleFiltersChange}
          onClearFilters={handleClearFilters}
          onNameSearchChange={handleNameSearchChange}
          loading={isLoading}
        />
    </UserManagementWrapper>
  );
}
